// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--prev-work-loc-main-sty {
    width: 100%;
    height: auto;
    padding-top: 10px;
    padding-left: 128px;
    padding-right: 128px;
    position: relative;
    max-width: 1920px;
}

.scl--prev-work-loc-main-sty .button-content-controller {
    width: 100%;
    display: flex;
    justify-content: end;
    gap: 10px;
    align-items: center;
    padding-top: 25px;
    padding-bottom: 25px;
}

.scl--prev-work-loc-main-sty .arrow-down {
    width: calc(100% - 241px);
    display: flex;
    justify-content: center;
    position: fixed;
    bottom: 24px;
    right: 0px;
    z-index: 100;
    pointer-events: none;
}

.scl--prev-work-loc-main-sty .arrow-down .center {
    pointer-events: auto;
}

.scl--prev-work-loc-main-sty .arrow-down button {
    width: 30px;
    height: 30px;
    background-color: #fff;
    border: 1px solid #0d0d0d1a;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    opacity: 0.5;
}

.scl--prev-work-loc-main-sty .arrow-down.active button {
    opacity: 1;
    transform: translateY(0);
    cursor: pointer;
}

.scl--prev-work-loc-main-sty .arrow-down.disabled button {
    opacity: 0;
    transform: translateY(8px);
    pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/page-controller-mod/page-serv/workflow/css/preview-local.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,0BAA0B;IAC1B,oBAAoB;AACxB","sourcesContent":[".scl--prev-work-loc-main-sty {\n    width: 100%;\n    height: auto;\n    padding-top: 10px;\n    padding-left: 128px;\n    padding-right: 128px;\n    position: relative;\n    max-width: 1920px;\n}\n\n.scl--prev-work-loc-main-sty .button-content-controller {\n    width: 100%;\n    display: flex;\n    justify-content: end;\n    gap: 10px;\n    align-items: center;\n    padding-top: 25px;\n    padding-bottom: 25px;\n}\n\n.scl--prev-work-loc-main-sty .arrow-down {\n    width: calc(100% - 241px);\n    display: flex;\n    justify-content: center;\n    position: fixed;\n    bottom: 24px;\n    right: 0px;\n    z-index: 100;\n    pointer-events: none;\n}\n\n.scl--prev-work-loc-main-sty .arrow-down .center {\n    pointer-events: auto;\n}\n\n.scl--prev-work-loc-main-sty .arrow-down button {\n    width: 30px;\n    height: 30px;\n    background-color: #fff;\n    border: 1px solid #0d0d0d1a;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    opacity: 0.5;\n}\n\n.scl--prev-work-loc-main-sty .arrow-down.active button {\n    opacity: 1;\n    transform: translateY(0);\n    cursor: pointer;\n}\n\n.scl--prev-work-loc-main-sty .arrow-down.disabled button {\n    opacity: 0;\n    transform: translateY(8px);\n    pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
